import config from 'config';
import * as yup from 'yup';

import { ReactComponent as GitHubFooterLogo } from 'asset/IconsPack/at_github_vector.svg';
import { ReactComponent as LinkedinFooterLogo } from 'asset/IconsPack/at_linkedin_vector.svg';
import { ReactComponent as TwitterFooterLogo } from 'asset/IconsPack/at_twitter_vector.svg';
import { ReactComponent as UserIconHat } from 'asset/IconsPack/at_user-02-hat.svg';
import { ReactComponent as UserIconSearch } from 'asset/IconsPack/at_user-03-search.svg';
import { ReactComponent as UserIconHeart } from 'asset/IconsPack/at_user-04-heart.svg';
import { ReactComponent as UserIconTick } from 'asset/IconsPack/at_user-05-tick.svg';
import { ReactComponent as GithubLogo } from 'asset/IconsPack/github.svg';
import { ReactComponent as LinkedinLogo } from 'asset/IconsPack/linkedin.svg';
import { ReactComponent as TwitterLogo } from 'asset/IconsPack/x_twitter.svg';
import DocSearchImg from 'asset/img/docs_search.png';
import NoRecordsImg from 'asset/img/no-records-found.svg';

const rowPerPage = [
    { label: '10 Entries', value: 10 },
    { label: '20 Entries', value: 20 },
];

const sortByFilters = [
    { name: 'created_at', label: 'Created' },
    { name: 'first_name', label: 'First Name' },
    { name: 'last_name', label: 'Last Name' },
    { name: 'uuid', label: 'User key' },
];

const invertDirection = {
    asc: 'desc',
    desc: 'asc',
};

const apiCallTableheader = [
    {
        name: 'USER',
        value: 'firstName',
    },
    {
        name: 'DOB',
        value: 'dateOfBirth',
    },
    {
        name: 'IDENTITY Verified',
        value: 'identity',
    },
    {
        name: 'Has Criminal Report',
        value: 'criminal',
    },
    {
        name: 'CREATED',
        value: 'created_at',
    },
    {
        name: 'USER ACCESS CODE',
        value: 'userAccessCode',
    },
];

const unauthorizedUserMessage = 'Your company has not been authorized for this action yet.';
const pendingAccountMessage = 'Please wait until the technical staff approves your account.';

const statusCopy = {
    true: 'Passed',
    false: 'Failed',
    TRUE: 'Passed',
    FALSE: 'Failed',
};

const fakeUserInfo = {
    firstName: 'John',
    middleName: 'Smith',
    lastName: 'Doe',
    dob: '01-01-1971',
    ssn: '',
    email: 'johndoe@email.com',
};

const workflowMessages = {
    default: {
        variant: 'default',
        message: 'Default workflow changed',
    },
    delete: {
        variant: 'default',
        message: 'Workflow deleted',
    },
    create: {
        variant: 'default',
        message: 'Workflow created',
    },
    save: {
        variant: 'default',
        message: 'Changes saved',
    },
    discard: {
        variant: 'default',
        message: 'Changes discarded',
    },
    rename: {
        variant: 'default',
        message: 'Workflow renamed',
    },
    idProofError: {
        variant: 'error',
        message: 'You need to select at least one type of Identity Proof.',
    },
    manualReview: {
        variant: 'default',
        message: 'Manual review initiated',
    },
};

const usaStates = [
    { name: 'ALABAMA', abbreviation: 'AL' },
    { name: 'ALASKA', abbreviation: 'AK' },
    { name: 'ARIZONA', abbreviation: 'AZ' },
    { name: 'ARKANSAS', abbreviation: 'AR' },
    { name: 'CALIFORNIA', abbreviation: 'CA' },
    { name: 'COLORADO', abbreviation: 'CO' },
    { name: 'CONNECTICUT', abbreviation: 'CT' },
    { name: 'DELAWARE', abbreviation: 'DE' },
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
    { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
    { name: 'FLORIDA', abbreviation: 'FL' },
    { name: 'GEORGIA', abbreviation: 'GA' },
    { name: 'HAWAII', abbreviation: 'HI' },
    { name: 'IDAHO', abbreviation: 'ID' },
    { name: 'ILLINOIS', abbreviation: 'IL' },
    { name: 'INDIANA', abbreviation: 'IN' },
    { name: 'IOWA', abbreviation: 'IA' },
    { name: 'KANSAS', abbreviation: 'KS' },
    { name: 'KENTUCKY', abbreviation: 'KY' },
    { name: 'LOUISIANA', abbreviation: 'LA' },
    { name: 'MAINE', abbreviation: 'ME' },
    { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
    { name: 'MARYLAND', abbreviation: 'MD' },
    { name: 'MASSACHUSETTS', abbreviation: 'MA' },
    { name: 'MICHIGAN', abbreviation: 'MI' },
    { name: 'MINNESOTA', abbreviation: 'MN' },
    { name: 'MISSISSIPPI', abbreviation: 'MS' },
    { name: 'MISSOURI', abbreviation: 'MO' },
    { name: 'MONTANA', abbreviation: 'MT' },
    { name: 'NEBRASKA', abbreviation: 'NE' },
    { name: 'NEVADA', abbreviation: 'NV' },
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
    { name: 'NEW JERSEY', abbreviation: 'NJ' },
    { name: 'NEW MEXICO', abbreviation: 'NM' },
    { name: 'NEW YORK', abbreviation: 'NY' },
    { name: 'NORTH CAROLINA', abbreviation: 'NC' },
    { name: 'NORTH DAKOTA', abbreviation: 'ND' },
    { name: 'OHIO', abbreviation: 'OH' },
    { name: 'OKLAHOMA', abbreviation: 'OK' },
    { name: 'OREGON', abbreviation: 'OR' },
    { name: 'PALAU', abbreviation: 'PW' },
    { name: 'PENNSYLVANIA', abbreviation: 'PA' },
    { name: 'RHODE ISLAND', abbreviation: 'RI' },
    { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
    { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
    { name: 'TENNESSEE', abbreviation: 'TN' },
    { name: 'TEXAS', abbreviation: 'TX' },
    { name: 'UTAH', abbreviation: 'UT' },
    { name: 'VERMONT', abbreviation: 'VT' },
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
    { name: 'VIRGINIA', abbreviation: 'VA' },
    { name: 'WASHINGTON', abbreviation: 'WA' },
    { name: 'WEST VIRGINIA', abbreviation: 'WV' },
    { name: 'WISCONSIN', abbreviation: 'WI' },
    { name: 'WYOMING', abbreviation: 'WY' },
];

const breakPoints = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400,
    xxl: 1920,
};

const buttonThemeSet = {
    button_1: { variant: 'contained', borderRadius: '6px', buttonClass: 'contained_button_1' },
    button_2: { variant: 'outlined', borderRadius: '6px', buttonClass: 'outlined_button_1' },
    button_3: { variant: 'contained', borderRadius: '15px', buttonClass: 'contained_button_2' },
    button_4: { variant: 'outlined', borderRadius: '15px', buttonClass: 'outlined_button_2' },
    button_5: { variant: 'contained', borderRadius: '0px', buttonClass: 'contained_button_3' },
    button_6: { variant: 'outlined', borderRadius: '0px', buttonClass: 'outlined_button_3' },
    button_7: { variant: 'contained', borderRadius: '44px', buttonClass: 'contained_button_4' },
    button_8: { variant: 'outlined', borderRadius: '44px', buttonClass: 'outlined_button_4' },
};

const userSearchValidationSchema = yup.object().shape({
    firstName: yup
        .string('Enter your First Name')
        .when(['userAccessCode', 'email', 'reservationId'], (uac, email, resId) => {
            if (uac === null && email === null && resId === null) {
                return yup.string().required('Enter your First Name').nullable();
            }
        })
        .nullable(),
    middleName: yup.string('Enter your Middle Name').nullable(),
    lastName: yup
        .string('Enter your Last Name')
        .when(['userAccessCode', 'email', 'reservationId'], (uac, email, resId) => {
            if (uac === null && email === null && resId === null) {
                return yup.string().required('Enter your Last Name').nullable();
            }
        })
        .nullable(),
    dateOfBirth: yup
        .string('Enter your Birth Date')
        .when(['userAccessCode', 'email', 'reservationId'], (uac, email, resId) => {
            if (uac === null && email === null && resId === null) {
                return yup.string().required('Enter your Birth Date').nullable();
            }
        })
        .nullable(),
    userAccessCode: yup.string('Enter User Access Code').nullable(),
    email: yup.string('Enter your Email').email('Enter a valid email').nullable(),
    reservationId: yup.string('Enter reservation Id').nullable(),
    platform: yup
        .string('Select platform ')
        .when('reservationId', (id) => {
            if (id !== null) {
                return yup.string().required('Select a platform').nullable();
            }
        })
        .nullable(),
});

const platformOptions = [
    { label: 'None', value: null },
    { label: 'Guesty', value: 'guesty' },
    { label: 'Hostaway', value: 'hostaway' },
    { label: 'Lodgify', value: 'lodgify' },
    { label: 'Hostfully', value: 'hostfully' },
    { label: 'OwnerRez', value: 'ownerrez' },
];

const productAnalyticsEvent = {
    register: 'Registration Started',
    comapanyDetails: 'Company Details Entered',
    reviewDetails: 'Application Reviewed',
    survey: 'Survey Viewed',

    USER_PROFILE_ADMIN_ENGAGEMENT: 'USER_PROFILE_ADMIN_ENGAGEMENT',

    GRAPH_PROMOTIONAL_CARD_CLICKED: 'GRAPH_PROMOTIONAL_CARD_CLICKED',
    GRAPH_VERIFICATION_TYPE_FILTER: 'GRAPH_VERIFICATION_TYPE_FILTER',
};

const ADMIN_ENGAGEMENT_TYPES = {
    USER_PROFILE_VISITED: 'USER_PROFILE_VISITED',
    USER_PII_UPDATED: 'USER_PII_UPDATED',
    WORKFLOW_ASSIGNED_TO_USER: 'WORKFLOW_ASSIGNED_TO_USER',
    UAC_COPIED: 'UAC_COPIED',
    MEDALLION_STATUS_CHECKED: 'LINK_EXPIRY_STATUS_CHECKED',
    IDV_STATUS_CHECKED: 'VERIFICATION_STATUS_CHECKED',
    USER_EVENT_TAB_ACCESSED: 'USER_EVENT_TAB_ACCESSED',
    USER_VERIFICATION_TAB_ACCESSED: 'USER_VERIFICATION_TAB_ACCESSED',
};

const voidDocumentStatus = ['document.rejected', 'document.voided', 'document.declined'];

const adminRole = {
    company_owner: 'Owner',
    company_admin: 'Admin',
    viewer: 'Viewer',
};

const adminTypes = {
    COMPANY_OWNER: adminRole.company_owner,
    COMPANY_ADMIN: adminRole.company_admin,
    COMPANY_VIEWER: adminRole.viewer,
};

const adminListTableHeader = [
    { _id: 1, name: 'Account', value: 'created_at' },
    { _id: 2, name: 'Role', value: 'type' },
    { _id: 3, name: 'Status', value: 'verified' },
    { _id: 4, name: 'Options', value: 'first_name' },
];

const adminListFilters = [
    { name: 'created_at', label: 'Created' },
    { name: 'first_name', label: 'First Name' },
    { name: 'last_name', label: 'Last Name' },
    { name: 'type', label: 'Role' },
    { name: 'verified', label: 'Status' },
];

const adminAccountStatus = {
    ACTIVE: 'active',
    PENDING: 'pending',
    SUSPENDED: 'suspended',
};

// feature flag is added for BAV feature, so we can toggle the feature, more info => https://www.martinfowler.com/articles/feature-toggles.html
const bankFeatureFlag = true;

const passportUncertainStatus = [
    'complete',
    'under_review',
    'parsing_failed',
    'Attention',
    'Failed',
    'Unknown',
];

const consentNameMap = {
    glb_purpose_and_dppa_purpose: 'GLBA and DPPA',
    fcra_purpose: 'FCRA',
    background_check_disclosure_accepted: 'Background check',
};

const guidesPaths = [
    'https://info.authenticate.com/shopify-integration',
    'https://info.authenticate.com/guesty-integration',
    'https://info.authenticate.com/hostaway-integration',
];

const Utils = {
    CHART_COLORS: [
        'rgba(2, 62, 138, 1)',
        'rgba(118, 198, 240, 1)',
        'rgba(188, 108, 37, 1)',
        'rgba(247, 178, 102, 1)',
        'rgba(0, 109, 119, 1)',
        'rgba(131, 197, 190, 1)',
    ],
};

const checksInfoUpdated = {
    'Docs Verified': 'Verified govt. ID',
    'Docs Unverified': 'Unverified govt. ID',
    'Quiz Verified': 'Verified quiz',
    'Quiz Unverified': 'Unverified quiz',
    'Bank Accounts Verified': 'Verified financial account ownership',
    'Bank Accounts Unverified': 'Unverified financial account ownership',
};

const checksInfo = [
    'Docs Verified',
    'Docs Unverified',
    'Quiz Verified',
    'Quiz Unverified',
    'Bank Accounts Verified',
    'Bank Accounts Unverified',
];

const hideCardStats = ['Quiz Verification', 'Financial Account Ownership Verification'];

const initialGraphData = { statistics: {} };

const KBAResultKeys = {
    numQuestions: 'Number of Questions',
    score: 'Quiz Score',
    status: 'Verification Status',
};

// reference: https://docs.stripe.com/error-codes
const STRIPE_ERROR_CODES = {
    CARD_DECLINED: 'card_declined',
    EXPIRED_CARD: 'expired_card',
    INCORRECT_CVC: 'incorrect_cvc',
    INCORRECT_NUMBER: 'incorrect_number',
    INVALID_CVC: 'invalid_cvc',
    INVALID_EXPIRY_MONTH: 'invalid_expiry_month',
    INVALID_EXPIRY_YEAR: 'invalid_expiry_year',
    INVALID_NUMBER: 'invalid_number',
    NO_ACCOUNT: 'no_account',
};

const STRIPE_ERROR_MESSAGES = {
    [STRIPE_ERROR_CODES.CARD_DECLINED]: 'Your card has declined.',
    [STRIPE_ERROR_CODES.EXPIRED_CARD]: 'Your card has expired.',
    [STRIPE_ERROR_CODES.INCORRECT_CVC]: "Your card's security code is incorrect.",
    [STRIPE_ERROR_CODES.INCORRECT_NUMBER]: 'Your card number is incorrect.',
    [STRIPE_ERROR_CODES.INVALID_CVC]: "Your card's security code is invalid.",
    [STRIPE_ERROR_CODES.INVALID_EXPIRY_MONTH]: "Your card's expiration month is incorrect.",
    [STRIPE_ERROR_CODES.INVALID_EXPIRY_YEAR]: "Your card's expiration year is incorrect.",
    [STRIPE_ERROR_CODES.INVALID_NUMBER]: 'Your card number is invalid.',
    [STRIPE_ERROR_CODES.NO_ACCOUNT]: 'The bank account could not be located.',
};

const STRIPE_ERROR = {
    CODES: STRIPE_ERROR_CODES,
    MESSAGES: STRIPE_ERROR_MESSAGES,
};

const CONSENT_MESSAGES = {
    CONSENT_AND_PERMISSIONS:
        'Please certify that you have the following consent and permissions to verify this user',
    SINGLE_BACKGROUND_CHECK: 'Please certify you have the following consent to verify this user',
    SINGLE_FCRA_PURPOSE: 'Please certify you have the following permission to verify this user',
    SINGLE_GLB_DPPA_PURPOSES:
        'Please certify you have the following permissions to verify this user',
    PERMISSION_AND_CONSENT:
        'Please certify you have the following permission and consent to verify this user',
    PERMISSIONS_AND_CONSENT:
        'Please certify you have the following permissions and consent to verify this user',
};

const LOW_CODE_SCRIPT_MAX_LINKS_PER_DAY = 5000;

const LOW_CODE_SCRIPT_MAX_DOMAINS = 10;

const LOW_CODE_SDK_MESSAGES = {
    base: 'Low Code SDK enabled. Your SDK key is ready.',
    disable: 'Low Code SDK disabled.',
    reactivate: 'Low Code SDK enabled.',
    saved: 'Low Code SDK settings saved.',
};

const licenseClasses = [
    {
        label: 'Class A',
        value: 'A',
    },
    {
        label: 'Class B',
        value: 'B',
    },
    {
        label: 'Class C',
        value: 'C',
    },
    {
        label: 'Class D',
        value: 'D',
    },
    {
        label: 'Class E',
        value: 'E',
    },
    {
        label: 'Class F',
        value: 'F',
    },

    {
        label: 'Class H',
        value: 'H',
    },
    {
        label: 'Class L',
        value: 'L',
    },
    {
        label: 'Class M',
        value: 'M',
    },
    {
        label: 'Class MJ',
        value: 'MJ',
    },
    {
        label: 'Class M1',
        value: 'M1',
    },
    {
        label: 'Class M2',
        value: 'M2',
    },

    {
        label: 'Class N',
        value: 'N',
    },
    {
        label: 'Class O',
        value: 'O',
    },
    {
        label: 'Class P',
        value: 'P',
    },
    {
        label: 'Class R',
        value: 'R',
    },
    {
        label: 'Class S',
        value: 'S',
    },
    {
        label: 'Class T',
        value: 'T',
    },
    {
        label: 'Class TPXS',
        value: 'TPXS',
    },

    {
        label: 'Class X',
        value: 'X',
    },
    {
        label: 'Class 1',
        value: '1',
    },
    {
        label: 'Class 2',
        value: '2',
    },
    {
        label: 'Class 3',
        value: '3',
    },
];

const PASSWORD_POLICY = {
    REGEX: /^(?:(?=.*\d)(?=.*[a-z]).{8,15}|.{15,})$/,
    ERROR_MESSAGE:
        'Make sure it has at least 15 characters OR at least 8 characters including a number and a lowercase letter',
};

// users table

const PAGE_SIZE = [
    { label: '10 Entries', value: 10 },
    { label: '20 Entries', value: 20 },
];

const SORT_OPTIONS = [
    { label: 'Oldest', value: 'oldest' },
    { label: 'Newest', value: 'newest' },
    { label: 'Last Name', value: 'last_name' },
];

const SORT_LABELS_TO_HIGHTLIGHT = {
    newest: 'Newest',
    oldest: 'Oldest',
    last_name: 'Last Name',
};

const USER_TABLE_TOOLTIP_CONTENTS = {
    VERIFICATION_STATUS: `Displays the user's verification progress, Not Started, Attempted, Reinitialized, Failed, Completed, along with the chosen verification method.`,
    IDENTITY_VERIFICATION: `The Identity Verification Status confirms if a user's identity has been validated through an authoritative database check.`,
    CRIMINAL_RECORD:
        'When initiated, this check returns crimes committed within the last seven years.',
    MEDALLION_LINK_EXPIRED: `Medallion™ link has expired.`,
    RE_INITIALIZED: `Medallion™ link has been reinitialized for the user.`,
};

const USERS_TABLE_HEADER = [
    {
        _id: 0,
        name: 'Name',
        value: 'fullName',
        showTooltip: false,
    },
    {
        _id: 1,
        name: 'Date of Birth',
        value: 'dateOfBirth',
        showTooltip: false,
    },
    {
        _id: 2,
        name: 'Verification Status',
        value: 'verificationStatus',
        showTooltip: true,
        tooltipContent: USER_TABLE_TOOLTIP_CONTENTS.VERIFICATION_STATUS,
    },
    {
        _id: 3,
        name: 'Identity Verified',
        value: 'identityVerified',
        showTooltip: true,
        tooltipContent: USER_TABLE_TOOLTIP_CONTENTS.IDENTITY_VERIFICATION,
    },
    {
        _id: 4,
        name: '7 Year Criminal Report',
        value: 'criminalRecord',
        showTooltip: true,
        tooltipContent: USER_TABLE_TOOLTIP_CONTENTS.CRIMINAL_RECORD,
    },
    {
        _id: 5,
        name: 'Created At',
        value: 'createdAt',
        showTooltip: false,
    },
    {
        _id: 6,
        name: 'User Access Code',
        value: 'userAccessCode',
        showTooltip: false,
    },
];

const RANGE_DATE_PICKER_MESSAGES = {
    MAX_LIMIT: `Duration's permissible limit is 2 years.`,
    INVALID_RANGE: 'End date must be after the start date.',
    FUTURE_DATE: 'Future date selection is not permissible.',
};

const VERIFICATION_TYPES = {
    GOVT_ID: 'govt_id',
    KBA: 'kba',
    BANK: 'bank',
    EEP: 'eep',
    MVR: 'mvr',
    SSN: 'ssn',
    TWOFA: '2fa',
    RISK_SCORE: 'risk_score',
    AUTH_DB: 'authoritative_db',
    CRIMINAL: 'has_criminal_record',
    SEVEN_YEAR: 'seven_year_criminal_report',
    EDUCATION: 'education',
    EMPLOYMENT: 'employment',
    PROFESSIONAL_LICENSE: 'professional_license',
    QUICK_VERIFY: 'quick_verify',
    GLOBAL_WATCHLIST: 'global_watchlist',
    SEX_OFFENDER: 'sex_offender',
};

const VERIFICATION_TYPE_LABELS = {
    [VERIFICATION_TYPES.GOVT_ID]: 'Government ID',
    [VERIFICATION_TYPES.KBA]: 'KBA',
    [VERIFICATION_TYPES.BANK]: 'Financial Account Ownership',
    [VERIFICATION_TYPES.EEP]: 'Employment',
    [VERIFICATION_TYPES.MVR]: 'Motor Vehicle Registration',
    [VERIFICATION_TYPES.SSN]: 'SSN',
    [VERIFICATION_TYPES.QUICK_VERIFY]: 'Quick Verify',
};

const VERIFICATION_STATUS_TYPES = {
    NOT_STARTED: 'NOT_STARTED',
    ATTEMPTED: 'ATTEMPTED',
    ERROR: 'ERROR',
    COMPLETED: 'COMPLETED',
    RE_INITIALIZED: 'RE_INITIALIZED',
    FAILED: 'FAILED',
};

const VERIFICATION_STATUS = {
    [VERIFICATION_STATUS_TYPES.NOT_STARTED]: 'Not Started',
    [VERIFICATION_STATUS_TYPES.ATTEMPTED]: 'Attempted',
    [VERIFICATION_STATUS_TYPES.ERROR]: 'Failed',
    [VERIFICATION_STATUS_TYPES.FAILED]: 'Failed',
    [VERIFICATION_STATUS_TYPES.COMPLETED]: 'Completed',
    [VERIFICATION_STATUS_TYPES.RE_INITIALIZED]: 'Reinitialized',
};

const VERIFICATION_STATUS_COLORS = {
    [VERIFICATION_STATUS_TYPES.ATTEMPTED]: '#175CD3',
    [VERIFICATION_STATUS_TYPES.COMPLETED]: '#027A48',
    [VERIFICATION_STATUS_TYPES.ERROR]: '#B42318',
    [VERIFICATION_STATUS_TYPES.FAILED]: '#B42318',
    [VERIFICATION_STATUS_TYPES.RE_INITIALIZED]: '#5925DC',
    default: '#374151',
};

const USER_TYPES = {
    NO_CODE: 'NO_CODE',
    API: 'API',
};

const MEDALLION_DEFAULT_LINK_EXPIRY_HOURS = 24;

const ID_MATCH_FAILURE_MESSAGES = {
    ID_DATA_NOT_MATCH:
        'We were able to read the document, but the information on the ID does not match the user input. Please make sure the user information matches the information on the ID and try again.',
    PASSPORT_DATA_NOT_MATCH:
        'We were able to read the document, but the information on the Passport does not match the user input. Please make sure the user information matches the information on the Passport and try again.',
};

const KBA_GENERATION_FAILURE_MESSAGES = {
    INCORRECT_USER_PII:
        'There was incorrect or insufficient information provided. Try updating the PII or adding SSN for better results.',
    IDENTITY_NOT_FOUND:
        'Checks for this user are restricted due to uncertainty of true identity. Please update the user object with correct information.',
    NOT_ENOUGH_QUESTION:
        'There were not enough questions available to generate a quiz for this user. Please try verifying the user with another method.',

    NOT_ENOUGH_QUESTION_2:
        'There were not enough questions available to generate a quiz for this user. Please try adding SSN for better results.',
};

const MEDALLION_ERRORS = {
    ID_TAMPER_CHECK_FAILED: 'ID failed tamper result checks.',
    EXPIRED_ID: 'The ID provided is expired.',
    INVALID_DOB: 'The dob on ID could not be read correctly.',
};

const TCM_TOOLTIP_CONTENTS = {
    ID_VERIFIED: `The Identity Verification Status confirms if a user's identity has been validated through an authoritative database check.`,
    CRIMINAL_RECORD: `When initiated, this check returns crimes committed within the last seven years.`,
    UNVERIFIED_USER: `Only verified users can be added to True Continuous Monitoring™`,
    RECORDS_FOUND: `Indicates whether any records were identified for the user during the monitoring period.`,
};

const TCM_TABLE_HEADER = [
    { id: 1, name: 'Name' },
    { id: 2, name: 'Date of Birth' },
    {
        id: 3,
        name: 'Identity Verified',
        tooltip: true,
        tooltipContent: TCM_TOOLTIP_CONTENTS.ID_VERIFIED,
    },
    {
        id: 4,
        name: '7 Year Criminal Report',
        tooltip: true,
        tooltipContent: TCM_TOOLTIP_CONTENTS.CRIMINAL_RECORD,
    },
    { id: 5, name: 'Status' },
    {
        id: 6,
        name: 'Records Found',
        tooltip: true,
        tooltipWidth: '200px',
        tooltipPosition: 'bottom-end',
        tooltipContent: TCM_TOOLTIP_CONTENTS.RECORDS_FOUND,
    },
    { id: 7, name: 'Enrolled On' },
];
const USER_SESSION_EXPIRE_MESSAGE = 'Your session has expired. Please log in.';

const RISK_PROFILES = {
    LOW: 'Low',
    MODERATE: 'Moderate',
    HIGH: 'High',
};

const RISK_PROFILE_COLORS = {
    [RISK_PROFILES.LOW]: 'green',
    [RISK_PROFILES.MODERATE]: 'yellow',
    [RISK_PROFILES.HIGH]: 'red',
};

const RISK_SCORE_NUDGE_STATUS = {
    [RISK_PROFILES.LOW]: 'success',
    [RISK_PROFILES.MODERATE]: 'warning',
    [RISK_PROFILES.HIGH]: 'cancel',
};

const RISK_SCORE_RING_COLOR = {
    [RISK_PROFILES.LOW]: '#12B76A',
    [RISK_PROFILES.MODERATE]: '#F79009',
    [RISK_PROFILES.HIGH]: '#F04438',
};

const RISK_SCORE_PROFILE_LABEL_COLOR = {
    [RISK_PROFILES.LOW]: '#D7F7D5',
    [RISK_PROFILES.MODERATE]: '#fffaeb',
    [RISK_PROFILES.HIGH]: '#FFD1D0',
};

const RUN_RISK_SCORE_NUDGE_DESCRIPTION =
    'Risk Score shows if user data matches our identity graph, providing a risk percentage based on the match or mismatch.';

const RUN_RISK_SCORE_TOOLTIP =
    'User insights from Risk Score involve understanding risk levels, engagement across channels, behavioral patterns, and user segmentation based on activity scores. Higher confidence scores typically indicate lower risk, aiding organizations in making informed decisions.';

const RUN_RISK_SCORE_DUMMY_PII_TOOLTIP =
    'Risk score require complete and valid user details — full name, email, phone, and address. This feature is unavailable if any information is missing or uses placeholder values.';

const RUN_RISK_INSIGHTS_DUMMY_PII_TOOLTIP =
    'Risk insights require complete and valid user details — full name, email, phone, and address. This feature is unavailable if any information is missing or uses placeholder values.';

const RUN_RISK_INSIGHT_TOOLTIP =
    "Risk Insights provides input data insights into how confident we are about the given person's identity, inputs, and risk level. Risk Insights are highly specific and provide high-value information. Our identity graph spans both the digital and terrestrial ecosystems and provides linkages between how individuals represent themselves professionally and personally.";

const RISK_SCORE_MATCH_CATEGORY = {
    TANGLED: 'tangled',
    UNKNOWN: 'unknown',
    HOUSEHOLD: 'household',
    SELF: 'self',
};

const RISK_SCORE_MATCH_NUDGE_ICONS = {
    [RISK_SCORE_MATCH_CATEGORY.TANGLED]: UserIconHat,
    [RISK_SCORE_MATCH_CATEGORY.UNKNOWN]: UserIconSearch,
    [RISK_SCORE_MATCH_CATEGORY.HOUSEHOLD]: UserIconHeart,
    [RISK_SCORE_MATCH_CATEGORY.SELF]: UserIconTick,
};

const RISK_SCORE_MATCH_COLORS = {
    [RISK_SCORE_MATCH_CATEGORY.TANGLED]: '#b66200',
    [RISK_SCORE_MATCH_CATEGORY.UNKNOWN]: '#6D6D6D',
    [RISK_SCORE_MATCH_CATEGORY.HOUSEHOLD]: '#0053B6',
    [RISK_SCORE_MATCH_CATEGORY.SELF]: '#00B65B',
};

const RISK_SCORE_MATCH_ITEMS_LABEL = {
    [RISK_SCORE_MATCH_CATEGORY.TANGLED]:
        'Following attributes were found to match another identity, which could suggest a higher risk of fraud; additional security measures are recommended.',
    [RISK_SCORE_MATCH_CATEGORY.UNKNOWN]:
        'Following attributes couldn’t be classified, which may or may not suggest a fraud risk.',
    [RISK_SCORE_MATCH_CATEGORY.HOUSEHOLD]:
        'Following attributes match another individual in the same household, indicating no fraud risk.',
    [RISK_SCORE_MATCH_CATEGORY.SELF]:
        'All of the following attributes pertain to a single identity.',
};

const RISK_SCORE_MATCH_NUDGE_TOOLTIP = {
    [RISK_SCORE_MATCH_CATEGORY.TANGLED]:
        'Increased fraud risk; recommended to add extra security checks.',
    [RISK_SCORE_MATCH_CATEGORY.UNKNOWN]: `The information could not be classified. This may or may not indicate a fraud risk.`,
    [RISK_SCORE_MATCH_CATEGORY.HOUSEHOLD]:
        'User information matches another individual in the same household; not indicating fraud risk.',
    [RISK_SCORE_MATCH_CATEGORY.SELF]:
        'The provided user information points to a singular identity.',
};

const RISK_INSIGHT_SOCIAL_PROFILE_TYPE = {
    X: 'X (formerly Twitter)',
    TWITTER: 'Twitter',
    LINKEDIN: 'Linkedin',
    GITHUB: 'Github',
};

const RISK_INSIGHT_SOCIAL_PROFILE_LOGO = {
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.GITHUB]: GithubLogo,
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.LINKEDIN]: LinkedinLogo,
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.TWITTER]: TwitterLogo,
};

const RISK_INSIGHT_SOCIAL_PROFILE_FOOTER_LOGO = {
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.GITHUB]: <GitHubFooterLogo />,
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.LINKEDIN]: <LinkedinFooterLogo />,
    [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.TWITTER]: <TwitterFooterLogo />,
};

const RISK_INSIGHT_SOCIAL_TYPE_URL_MAP = {
    twitterUrl: [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.TWITTER],
    linkedInUrl: [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.LINKEDIN],
    githubUrl: [RISK_INSIGHT_SOCIAL_PROFILE_TYPE.GITHUB],
};

const RISK_INSIGHT_MOBILE_HEADERS = {
    EMAIL: 'email',
    PHONE: 'phone',
    ADDITIONAL_DATA: 'additional emails',
    EMPLOYMENT_SOCIAL_PROFILES: 'employment & social',
};

const RISK_SCORE_INITIATE_METHODS = {
    USER_CREATION: 'USER_CREATION',
    MAIN_NUDGE: 'MAIN_NUDGE',
    INSIGHTS_TAB: 'INSIGHTS_TAB',
};

const RISK_SCORE_DOC_LINK = 'https://info.authenticate.com/score-inputs';

const RISK_INSIGHTS_DOC_LINK = 'https://info.authenticate.com/verify-inputs';

const RISK_ASSESSMENT_TYPES = {
    RISK_SCORE: 'Risk Score',
    RISK_INSIGHTS: 'Risk Insights',
};

const USER_RISK_SCORE = {
    PROFILES: RISK_PROFILES,
    COLORS: RISK_PROFILE_COLORS,
    NUDGE_STATUS: RISK_SCORE_NUDGE_STATUS,
    RUN_RISK_SCORE_DESC: RUN_RISK_SCORE_NUDGE_DESCRIPTION,
    RUN_RISK_SCORE_TOOLTIP: RUN_RISK_SCORE_TOOLTIP,
    RISK_SCORE_RING_COLOR: RISK_SCORE_RING_COLOR,
    RISK_SCORE_PROFILE_LABEL_COLOR: RISK_SCORE_PROFILE_LABEL_COLOR,
    RISK_SCORE_MATCH: {
        CATEGORY: RISK_SCORE_MATCH_CATEGORY,
        COLORS: RISK_SCORE_MATCH_COLORS,
        USER_ICONS: RISK_SCORE_MATCH_NUDGE_ICONS,
        TOOLTIPS: RISK_SCORE_MATCH_NUDGE_TOOLTIP,
        ITEMS_LABEL: RISK_SCORE_MATCH_ITEMS_LABEL,
    },
    RISK_SCORE_DOC_LINK: RISK_SCORE_DOC_LINK,
    INITIATE_METHODS: RISK_SCORE_INITIATE_METHODS,
    RUN_RISK_SCORE_DUMMY_PII_TOOLTIP,
};

const USER_RISK_INSIGHT = {
    SOCIAL_PROFILE: {
        TYPE: RISK_INSIGHT_SOCIAL_PROFILE_TYPE,
        LOGO: RISK_INSIGHT_SOCIAL_PROFILE_LOGO,
        FOOTER_LOGO: RISK_INSIGHT_SOCIAL_PROFILE_FOOTER_LOGO,
        URL_MAP: RISK_INSIGHT_SOCIAL_TYPE_URL_MAP,
    },
    MOBILE_HEADERS: RISK_INSIGHT_MOBILE_HEADERS,
    RISK_INSIGHTS_DOC_LINK: RISK_INSIGHTS_DOC_LINK,
    RISK_INSIGHT_FORM_TOOLTIPS: {
        EMAIL: 'Add additional email addresses if available. This helps improve data matching and ensures more accurate results',
        PHONE: 'Add additional phone numbers if available. This helps improve data matching and ensures more accurate results.',
    },
    RUN_RISK_INSIGHT_TOOLTIP,
    RUN_RISK_INSIGHTS_DUMMY_PII_TOOLTIP,
};

const USER_PROFILE_ACTIVE_MODAL_TYPE = {
    RISK_INSIGHT_EMPLOYMENT_FORM: 'RISK_INSIGHT_EMPLOYMENT_FORM',
};

const DEFAULT_AUTH_DB_FAILURE_MESSAGE = {
    ACTUAL_MESSAGE:
        'Could not verify the user details from the ID. Please try a different verification method or contact support.',
    UPDATED_MESSAGE:
        'User details could not be verified in the Authoritative Databases. Please check that all PII is accurate. If the issue persists, try an alternative verification method or contact support.',
};

const COMMON_EMAIL_DOMAINS = ['gmail', 'yahoo', 'outlook', 'hotmail', 'icloud', 'zoho', 'proton'];

const SEVEN_YEAR_CHECK_STATUS = {
    UNDER_REVIEW: 'UNDER_REVIEW',
    FOUND: 'FOUND',
    CLEAR: 'CLEAR',
    IN_PROGRESS: 'IN_PROGRESS',
};

const COMPANY_AGREEMENT_STATUS = {
    CREATION_INPROGRESS: 'creation_inprogress',
    AGREEMENT_CREATED: 'agreement_created',
};

export const recordsIcon = {
    COMPLETE: NoRecordsImg,
    PENDING: DocSearchImg,
};

export const RECORD_STATUS = {
    COMPLETE: 'COMPLETE',
    PENDING: 'PENDING',
};

const COMPANY_STATUS = {
    REJECTED: 'rejected',
    REVOKED: 'revoked',
    APPROVED: 'approved',
    PENDING: 'pending',
};

const DEFAULT_LINK_EXPIRATION_TIME = 23;

const VERIFICATION_OPTIONS = {
    BOTH: 'BOTH',
    DOCUMENT_ONLY: 'DOCUMENT_ONLY',
    EITHER: 'EITHER',
};

const COMPANY_ACCESS_CODES = {
    DOT_DEV: '0293a872-5324-4063-8a50-b307adaf7a57',
    AUTHENTICATE_QA: '263f6d39-3dc3-43f8-bb3e-c38b9c02038b',
};

export const ADDRESS_FIELDS_BLOCKED_CUSTOMERS = [
    COMPANY_ACCESS_CODES.DOT_DEV,
    COMPANY_ACCESS_CODES.AUTHENTICATE_QA,
];

const IS_SANDBOX_ENV = new Set(['sandbox', 'sandbox-dev', 'sandbox-dev-local']).has(
    process.env.REACT_APP_BUILD_ENV
);

const IS_SANDBOX_LOGIN_ACCESSIBLE = new Set(['sandbox', 'sandbox-dev', 'sandbox-dev-local']).has(
    process.env.REACT_APP_BUILD_ENV
);

const SANDBOX_BANNER_TEXT = {
    DEFAULT: 'You are testing in sandbox. Changes made here will not affect your live account.',
    USER_PROFILE:
        'You are testing in sandbox. Actual verifications are mocked. Records do not persist or reflect real data.',
    INTEGRATION: 'You are testing in sandbox. To access Integrations, switch to Production.',
};

const SANDBOX_TOOLTIP_TEXT = {
    CUSTOM_EMAIL: 'Custom email is disabled in sandbox.',
    TEAM_MEMBERS: 'Adding members is disabled in the Sandbox environment.',
    MEDALLION_NOTIFICATIONS: 'Medallion notifications are disabled in sandbox.',
    PROFESSIONAL_LICENSE: 'Professional license verification is disabled in sandbox.',
    FAOV: 'Financial Account Ownership verification is disabled in sandbox.',
};

// Copy for the "Request Sandbox" action, shared by the setup guide and the navbar button.
export const REQUEST_SANDBOX_TOOLTIP = {
    AGREEMENT_PENDING: 'Available once your company agreement has been approved.',
    REQUEST_SENT:
        "Your sandbox request has been received and is being processed. Our team will notify you once it's ready.",
};

// Copy for setup-guide actions that stay locked until the account (company agreement) is approved.
export const SETUP_GUIDE_TOOLTIP = {
    ACCOUNT_APPROVAL_PENDING: 'Available once your account has been approved.',
};

const isSandBoxDevEnv =
    process.env.REACT_APP_BUILD_ENV === 'sandbox-dev' ? 'Sandbox Dev' : 'Sandbox';

const SANDBOX_TEXT = IS_SANDBOX_ENV ? isSandBoxDevEnv : '';

const TOASTER_VARIANTS = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

export const MEDALLION_BASE_URL = config.APPLICATION.MEDALLION_LINK_URL;

export const METHOD_OUTCOME_LABELS = {
    [VERIFICATION_TYPES.GOVT_ID]: 'Govt ID',
    [VERIFICATION_TYPES.KBA]: 'KBA',
    [VERIFICATION_TYPES.BANK]: 'FAO',
    [VERIFICATION_TYPES.SSN]: 'SSN',
    [VERIFICATION_TYPES.QUICK_VERIFY]: 'Quick Verify',
};

// Spinner diameter per button size variant; keeps the loader proportional.
export const BUTTON_SPINNER_SIZE = {
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 22,
};

export const DATA_TYPES = {
    STRING: 'string',
    OBJECT: 'object',
};

export {
    rowPerPage,
    sortByFilters,
    invertDirection,
    apiCallTableheader,
    unauthorizedUserMessage,
    pendingAccountMessage,
    statusCopy,
    fakeUserInfo,
    workflowMessages,
    breakPoints,
    usaStates,
    buttonThemeSet,
    userSearchValidationSchema,
    platformOptions,
    productAnalyticsEvent,
    voidDocumentStatus,
    adminRole,
    adminListTableHeader,
    adminListFilters,
    adminTypes,
    adminAccountStatus,
    bankFeatureFlag,
    passportUncertainStatus,
    consentNameMap,
    guidesPaths,
    Utils,
    checksInfo,
    checksInfoUpdated,
    initialGraphData,
    hideCardStats,
    KBAResultKeys,
    STRIPE_ERROR,
    CONSENT_MESSAGES,
    LOW_CODE_SCRIPT_MAX_LINKS_PER_DAY,
    LOW_CODE_SCRIPT_MAX_DOMAINS,
    LOW_CODE_SDK_MESSAGES,
    licenseClasses,
    PASSWORD_POLICY,
    PAGE_SIZE,
    SORT_OPTIONS,
    SORT_LABELS_TO_HIGHTLIGHT,
    USER_TABLE_TOOLTIP_CONTENTS,
    USERS_TABLE_HEADER,
    RANGE_DATE_PICKER_MESSAGES,
    VERIFICATION_TYPES,
    VERIFICATION_TYPE_LABELS,
    VERIFICATION_STATUS_TYPES,
    VERIFICATION_STATUS,
    USER_TYPES,
    VERIFICATION_STATUS_COLORS,
    MEDALLION_DEFAULT_LINK_EXPIRY_HOURS,
    KBA_GENERATION_FAILURE_MESSAGES,
    ADMIN_ENGAGEMENT_TYPES,
    TCM_TOOLTIP_CONTENTS,
    TCM_TABLE_HEADER,
    USER_SESSION_EXPIRE_MESSAGE,
    USER_RISK_SCORE,
    USER_RISK_INSIGHT,
    USER_PROFILE_ACTIVE_MODAL_TYPE,
    ID_MATCH_FAILURE_MESSAGES,
    DEFAULT_AUTH_DB_FAILURE_MESSAGE,
    COMMON_EMAIL_DOMAINS,
    SEVEN_YEAR_CHECK_STATUS,
    COMPANY_AGREEMENT_STATUS,
    DEFAULT_LINK_EXPIRATION_TIME,
    COMPANY_STATUS,
    RISK_ASSESSMENT_TYPES,
    VERIFICATION_OPTIONS,
    MEDALLION_ERRORS,
    IS_SANDBOX_ENV,
    IS_SANDBOX_LOGIN_ACCESSIBLE,
    SANDBOX_BANNER_TEXT,
    SANDBOX_TOOLTIP_TEXT,
    SANDBOX_TEXT,
    TOASTER_VARIANTS,
};
